import React from 'react';
import {
	type FormSwitchProps as FormSwitchPropsDS,
	FormSwitch as FormSwitchDS,
} from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

interface FormSwitchProps extends Omit<
	FormSwitchPropsDS,
	'messageWrapper' | 'classNames'
> {}

export const FormSwitch = (props: FormSwitchProps) => (
	<FormSwitchDS
		{...props}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? { messages: [] }}
		messageWrapper={MessageWrapper}
	/>
);
